document.addEventListener('click', async function (e) {
    const btnModalEliminarMaquina = e.target.closest('#btnModalEliminarMaquina');
    if (!btnModalEliminarMaquina) return;

    const idMaquina     = btnModalEliminarMaquina.getAttribute("data-id");
    const formEliminar  = document.querySelector("#formEliminarMaquina");
    const modalEliminar = document.querySelector("#ModalEliminarMaquina");

    if (!idMaquina || !formEliminar || !modalEliminar) {
        if (typeof lanzarAlerta === 'function') {
            lanzarAlerta("Faltan parámetros para eliminar la máquina.", "alerta-roja");
        }
        return;
    }

    const requestOptions = {
        method: "GET",
        credentials: "include",
        headers: { "Content-Type": "application/json" },
        redirect: "follow",
    };

    const url = `/api/configuracion/maquinas/infoMaquina?idMaquina=${idMaquina}`;

    try {
        const response = await fetch(url, requestOptions);

        if (!response.ok) {
            throw new Error(`Error HTTP: ${response.status}`);
        }

        const result = await response.json();
        const data   = result.result[0];

        if (!data) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("No se encontró información de la máquina.", "alerta-roja");
            }
            setTimeout(() => { window.location.reload(); }, 1500);
            return;
        }

        modalEliminar.classList.add('modal--show');

        const inputIdMaquina = formEliminar.querySelector('#idMaquinaEliminar');
        const strongNombre   = modalEliminar.querySelector('#nombreEliminarMaquina');

        if (inputIdMaquina) inputIdMaquina.value      = data.idMaquina     || "";
        if (strongNombre)   strongNombre.textContent  = data.nombreMaquina || "";

    } catch (error) {
        console.error("Error al obtener información de la máquina:", error);
        if (typeof lanzarAlerta === "function") {
            lanzarAlerta("No se pudo cargar la información de la máquina.", "alerta-roja");
        }
    }
});

document.addEventListener('submit', async (e) => {
    if (e.target.id === 'formEliminarMaquina') {
        e.preventDefault();
        const formulario    = e.target;
        const modalEliminar = document.querySelector("#ModalEliminarMaquina");
        const btnSubmit     = formulario.querySelector('#btnEliminarMaquina');
        const spinner       = formulario.querySelector('#spinner');
        const formData      = new FormData(formulario);
        if (!formulario || !modalEliminar || !btnSubmit || !spinner) {
            if (typeof lanzarAlerta === 'function') {
                lanzarAlerta("Faltan parámetros para eliminar la máquina.", "alerta-roja");
            }
            return;
        }
        btnSubmit.disabled = true;
        spinner.style.display = 'inline-block';
        try {
            const respuesta = await fetch('/api/configuracion/maquinas/eliminar', {
                method: 'POST',
                body: formData
            });
            const json      = await respuesta.json();
            const status    = respuesta.status;
            const resultado = json.result;

            if (status !== 200) {
                alert("Error crítico al procesar la solicitud.");
                setTimeout(() => { window.location.reload(); }, 1000);
                return;
            }

            if (resultado.hayErrores) {
                resultado.errores.forEach(error => {
                    lanzarAlerta(error.mensaje, error.clase);
                });
                btnSubmit.disabled = false;
                spinner.style.display = 'none';
                modalEliminar.classList.remove('modal--show');
            }
            if (!resultado.hayErrores) {
                lanzarAlerta("Máquina eliminada correctamente.", "alerta-verde");
                setTimeout(() => { window.location.reload(); }, 800);
            }

        } catch (error) {
            console.error("Error:", error);
            modalEliminar.classList.remove('modal--show');
            btnSubmit.disabled = false;
            spinner.style.display = 'none';
        }
    }
});
